import { TWindowType, WindowTypes } from 'store/pageStore/types';

export const checkScreenType = (
	currentWindowType: TWindowType,
	checkedWindowType: TWindowType
): boolean => currentWindowType === checkedWindowType;

export const getScreenType = (windowWidth: number | undefined) => {
	if (!windowWidth) {
		return WindowTypes.desktop;
	}
	if (windowWidth > 1365) {
		return WindowTypes.desktop;
	}
	if (windowWidth > 1023) {
		return WindowTypes.laptop;
	}
	if (windowWidth > 767) {
		return WindowTypes.tablet;
	}
	return WindowTypes.mobile;
};
